import reqwest from "reqwest";
import md5 from "../../common/util/md5";
import commonTools from "../../common/util/util";
import { devType,isTest } from "../../config";

/** 这个文件中封装了一些常用的工具函数 **/
console.log("youheWechat环境:",isTest? "测试" : "线上")
const devwechat_id = 10
const devToken = "aec6f5cad9b17d844b312a5327ea258b" // 101172885
const tools = {
  isTest,
  host: "//open.", // 接口地址
  testHost: "test======================qingtingxiaoshuo.com",
  testCpsHost: "cps.huangbianyu.cn",//测试环境请求cps的域名
  proName: "youheWechat",
  domainName: "",
  accreditHost: "",
  version: 1,
  app_secret: "4b6017ec4deb3c4f385b979d0e9cd7aa",
  user_token: "",
  wechat_id: "",
  user_id: "",
  appId: "wx6ab1ce8635991bc0",
  app_key: "3779629472",
  loadFirst(callback,App){
    // console.log("83小说跳转")
    // if(window.location.origin.indexOf("83xiaoshuo.cn")!== -1){
    //   window.location.href = "mymanbandeng.com"
    // }
    let cookieData = JSON.parse(commonTools.cookieObj()["cookieData"]||"{}");
    this.wechat_id = devType ? devwechat_id : cookieData.wechat_id;
    this.user_id = cookieData.user_id;
    this.user_token = devType ? devToken : ((cookieData.user_token) || "")
    if(this.user_token == "linshitoken"){
      this.user_token = "";
    }
    this.domainName = cookieData.domainName;
    commonTools.cnzzData.property = cookieData.property;
    this.accreditHost = cookieData.accreditHost;
    this.host = this.host + this.domainName;
    // 清除请求失败的接口
    sessionStorage.removeItem("urls");
    
    let par = commonTools.searchPar();
    let obj = {channel_id: (par.channel_id) || "",promotions_id: (par.promotions_id) || ""};
    localStorage.setItem("_promotion_data",JSON.stringify(obj));
    if(!!par.fontSize){localStorage.setItem('_font_size',par.fontSize)}
    if(!!par.backColor){localStorage.setItem('_default_back_color',par.backColor)}
    if(!!par.fontColor){localStorage.setItem('_default_color',par.fontColor)}

    let tag = devType ? (!this.user_token) : (!this.user_token || true)
    console.log('tag: ', tag)
    if(tag){
      // 未登录
      let tempData = {};
      reqwest(commonTools.getData({
        host: "https://weixin.huangbianyu.cn",
        url: "/zh/user/userCookie",
        data: {
          source: document.location.hostname
        }
      },this)).then(res => {
        tempData = res.result.data || {};
      }).always(()=>{
        this.wechat_id = tempData.wechat_id;
        this.user_id = tempData.user_id;
        this.user_token = (tempData.user_token) || "";
        this.open_id = tempData.open_id || "";
        commonTools.cnzzData.property = tempData.property;
        if(!this.user_token){
          commonTools.getAccredit(this.accreditHost || this.domainName);
        }else{
          this.loginEnd(par,callback,App);
        }
      });
    }else{
      this.loginEnd(par,callback,App);
    }
  },
  loginEnd(par,callback,App){
    // 已登录
    if(!!sessionStorage.getItem("logintime") && new Date().getTime()-sessionStorage.getItem("logintime")>=(60*60*1000*2)){
      sessionStorage.removeItem("logintime");
      commonTools.getAccredit(this.accreditHost || this.domainName);
    }else{
      sessionStorage.setItem("logintime",new Date().getTime());

      if(document.location.hostname.substr(document.location.hostname.lastIndexOf(this.testHost)) == this.testHost){
        // 我是在测试环境域名下
        this.testCpsHost = "testcps.manhama.cn";
      }
      
      this.ajax({
        url: "/zh/user/updateLogintime",
        method:'post',
        isUser: true,
        isWechatId: true,
      });

      if(!!par.promotions_id){
        this.ajax({
          url: "/zh/additional/pv",
          method:'post',
          isUser: true,
          data: {
            promotions_id: par.promotions_id
          }
        });
      }

      this.ajax({
        url: "/zh/wechat/info", // URL
        isWechatId: true,
        callback: res => {
          console.log('请求接口123：', res)
          try{
            if (res.result.status.code == 0) {
              commonTools.cnzzData = res.result.data;
              localStorage.setItem('vipUrl', res.result.data.vip_url)
            }
            commonTools.addCnzz();
          }catch(e){}
        },
        alwaysFun: ()=>{
          if(!!callback){
            callback(App);
          }
        }
      });
    }
  },
  ajax(data){
    console.log(data,this.user_token)
    if(data && data.data){
      data.data.wechat_id = this.wechat_id
      data.data.user_token = this.user_token
    }
    if(!this.user_token){
      commonTools.getAccredit(this.accreditHost || this.domainName);
      return false;
    }else{
      if(!!sessionStorage.getItem("logintime") && new Date().getTime()-sessionStorage.getItem("logintime")>=(60*60*1000*2)){
        sessionStorage.removeItem("logintime");
        commonTools.getAccredit(this.accreditHost || this.domainName);
        return false;
      }
    }
    let curUrl = data.url + commonTools.jsonToStr(data.data);
    let localUrl = JSON.parse(sessionStorage.getItem("urls")||"[]");
    if(localUrl.indexOf(curUrl)>=0){
      // 存在就不继续请求
      return false;
    }
    localUrl.push(curUrl);
    sessionStorage.setItem("urls",JSON.stringify(localUrl));

    let dataPar = commonTools.getData(data,this);
    let par = commonTools.searchPar();
    if(!!par.channel_id&&!!par.promotions_id&&!this.postClick){
      this.postClick = true;
      let tempData = {
        promotion_id: par.promotions_id,
        random: commonTools.randomNum(6),
        timestamp: new Date().getTime(),
        user_id: this.user_id,
        app_secret: "r5e2t85tyu142u665698fzu",
        app_key: "5288971"
      };
      let str = `promotion_id${tempData.promotion_id}random${tempData.random}timestamp${tempData.timestamp}user_id${tempData.user_id}${tempData.app_secret}`;
      console.log(str);
      tempData.access_token = md5.hexMD5(str).toUpperCase();
      reqwest({
        url: '//'+this.testCpsHost+'/promotion/link_click_count',
        method: 'get',
        crossOrigin: true, // 开启CORS跨域
        withCredentials: true, // 请求头中是否带cookie，有利于后端开发保持他们需要的session
        data: tempData, // 参数，弄成json字符串
        type: "json" // 参数类型JSON
      })
      reqwest({
        url: '//'+this.testCpsHost+'/promotion/link_read_count',
        method: 'get',
        crossOrigin: true, // 开启CORS跨域
        withCredentials: true, // 请求头中是否带cookie，有利于后端开发保持他们需要的session
        data: tempData, // 参数，弄成json字符串
        type: "json" // 参数类型JSON
      })
      
      reqwest(commonTools.getData({
        url: '/zh/user/updateChannel',
        isUser: true,
        isWechatId: true,
        method:'post',
        data: {
          channel_id: par.channel_id,
          promotions_id: par.promotions_id
        }
      },this));
    }
    reqwest(dataPar).then(res => {
      if (res.result.status.code == 30016 || res.result.status.code == 30017 || res.result.status.code == 30024) {
        if(this.user_token != "buqushouquan"){
          commonTools.getAccredit(this.accreditHost || this.domainName);
        }
      }
      if (typeof data.callback == "function") {
        data.callback(res);
      }
    }).catch(e=>{
      e.requestPar = dataPar;
      commonTools.checkLog(e,this);
    }).always(()=>{
      let localUrl = JSON.parse(sessionStorage.getItem("urls")||"[]");
      localUrl.splice(localUrl.indexOf(curUrl),1);
      sessionStorage.setItem("urls",JSON.stringify(localUrl));
      if(typeof data.alwaysFun == "function"){
        try{data.alwaysFun();}catch(e){}
      }
    });
  }
};

export default tools;
